import { createGlobalStyle } from 'styled-components';
import reset from 'styled-reset';

import NotoSansLightOtf from './fonts/NotoSans/NotoSansKR-Light.otf';
import NotoSansLightWoff from './fonts/NotoSans/NotoSansKR-Light.woff';
import NotoSansLightWoff2 from './fonts/NotoSans/NotoSansKR-Light.woff2';
import NotoSansRegularOtf from './fonts/NotoSans/NotoSansKR-Regular.otf';
import NotoSansRegularWoff from './fonts/NotoSans/NotoSansKR-Regular.woff';
import NotoSansRegularWoff2 from './fonts/NotoSans/NotoSansKR-Regular.woff2';
import NotoSansMediumOtf from './fonts/NotoSans/NotoSansKR-Medium.otf';
import NotoSansMediumWoff from './fonts/NotoSans/NotoSansKR-Medium.woff';
import NotoSansMediumWoff2 from './fonts/NotoSans/NotoSansKR-Medium.woff2';
import NotoSansBoldOtf from './fonts/NotoSans/NotoSansKR-Bold.otf';
import NotoSansBoldWoff from './fonts/NotoSans/NotoSansKR-Bold.woff';
import NotoSansBoldWoff2 from './fonts/NotoSans/NotoSansKR-Bold.woff2';

const GlobalStyle = createGlobalStyle`
  ${reset}
  :root {
    font-size: 16px;
  }


  @font-face {
    font-family: 'Noto Sans CJK KR';
    font-style: normal;
    font-weight: 300;
    src: url(${NotoSansLightWoff2}) format('woff2'),
    url(${NotoSansLightWoff}) format('woff'),
    url(${NotoSansLightOtf}) format('truetype')
  };

  @font-face {
    font-family: 'Noto Sans CJK KR';
    font-style: normal;
    font-weight: 400;
    src: url(${NotoSansRegularWoff2}) format('woff2'),
    url(${NotoSansRegularWoff}) format('woff'),
    url(${NotoSansRegularOtf}) format('truetype')
  };

  @font-face {
    font-family: 'Noto Sans CJK KR';
    font-style: normal;
    font-weight: 500;
    src: url(${NotoSansMediumWoff2}) format('woff2'),
    url(${NotoSansMediumWoff}) format('woff'),
    url(${NotoSansMediumOtf}) format('truetype')
  };

  @font-face {
    font-family: 'Noto Sans CJK KR';
    font-style: normal;
    font-weight: 700;
    src: url(${NotoSansBoldWoff2}) format('woff2'),
    url(${NotoSansBoldWoff}) format('woff'),
    url(${NotoSansBoldOtf}) format('truetype')
  };



  * {
    box-sizing: border-box;
    font-family: 'Noto Sans CJK KR', sans-serif !important;
    margin: 0;
    padding: 0;
    word-break:keep-all;
    color: #0e0e0e;
  }

  body{
    width: 100%;
  }

  button,
  input {
    background-color: transparent;
    outline: none;
    border: none;
    font-size: inherit;
  }

  button {
    transition: opacity 0.3s 
  }

  button:hover{
    cursor: pointer;
    opacity: 0.8;
  }

  button:active {
    opacity: 0.7;
  }

  ul,li,ol {
    list-style: none;
    
  }

  a {
    color: inherit;
    text-decoration: none;
  }

  h1, h2, h3{
    line-height: 1.6;
  }

  p {
    line-height: 1.7;
  }
  
  strong {
    font-weight: 700;
  }
  
  img {
    -webkit-user-select: none;
  }

`;

export default GlobalStyle;
